import { Observable } from 'rxjs';

export enum EBulkCreateInvoiceStatus {
  PENDING = 'PENDING',
  PROCESSING = 'PROCESSING',
  COMPLETED = 'COMPLETED',
  FAILED = 'FAILED',
}

export interface IBulkCreateInvoiceColumn<T> {
  key: keyof T;
  header: string;
  formatter?: (item: T) => string;
}

export interface IBulkCreateInvoiceActionConfig<T extends Record<string, any>> {
  items: T[];
  idKey: keyof T;
  errorKey?: keyof T;
  columns: IBulkCreateInvoiceColumn<T>[];
  title?: string;
  actionLabel?: string;
  actionFn: (id: number) => Observable<any>;
}
